





















































import AnimationResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/AnimationService/AnimationResponse";
import {
    BACKGROUND_IMAGE_RATIO,
    NATURE_SOUND_COVER_IMAGE_RATIO,
} from "@/appSettings";

import { Vue, Component, Watch } from "vue-property-decorator";
import CreateBackgroundMixViewModel from "@models/natureSound/createBackgroundMixViewModel";
import BackgroundFileViewModel from "@models/natureSound/backgroundFileViewModel";

@Component
export default class PageCreateNatureSoundComponent extends Vue {
    languages: string[] = [];
    isLoading = false;
    coverImageRatio = NATURE_SOUND_COVER_IMAGE_RATIO;
    backgroundImageRatio = BACKGROUND_IMAGE_RATIO;
    backFiles: BackgroundFileViewModel[] = [];

    get title(): string {
        return this.id
            ? "Редактирование микса звуков"
            : "Добавление микса звуков";
    }

    get id(): number {
        const routeId = this.$route.params.id;
        return routeId ? Number(routeId) : 0;
    }

    vm: CreateBackgroundMixViewModel = new CreateBackgroundMixViewModel();

    onAnimationChanged(item: AnimationResponse) {
        this.vm.animationUrl = item.Url;
    }

    async created() {
        this.languages = await this.$cacheProvider.getLanguagesAsync();
        this.vm.initLanguages(this.languages);
        const catRes = await this.$api.BackgroundFileService.getBackgroundFilesAsync();
        this.backFiles = (catRes || []).map((x) => new BackgroundFileViewModel(x));
        if (this.$route.params.id) {
            await this.fetchData();
        }
    }

    async fetchData() {
        this.isLoading = true;
        const res = await this.$api.BackgroundFileService.getMixDetailsAsync(this.id);
        this.vm.fromServerModel(res);
        this.isLoading = false;
    }

    async save() {
        const isValid = (this.$refs.validator as any).isValid();
        if (!isValid) return;
        this.isLoading = true;
        const request = this.vm.toServerModel();
        const res = await this.$api.BackgroundFileService.updateMixAsync(request);
        if (res) {
            this.$dialog.success("Микс звуков успешно обновлен");
            this.$router.back();
        }
        this.isLoading = false;
    }

    // audioChanged(file: File) {
    //     this.vm.audio.audioFile = file;
    // }

    // deleteAudio() {
    //     this.vm.audio.audioFile = null;
    //     this.vm.audio.audioUrl = null;
    // }
}
